import React from 'react'
import { Field } from 'formik'
import { TextField as MuiTextField } from 'formik-material-ui'
import { withStyles } from '@material-ui/core'

const styles = theme => ({
  textField: {
    margin: 0
  }
})

export const TextFieldBase = ({ classes, children, className, ...rest }) => (
  <Field
    component={MuiTextField}
    className={`${classes.textField} ${className}`}
    fullWidth
    margin="dense"
    variant="outlined"
    {...rest}
  >
    {children}
  </Field>
)

export const TextField = withStyles(styles)(TextFieldBase)
